
$(document).ready(function(){

  var screen_size =  $(window).width();

  if(screen_size <= 767)
  {
    $('.mobile_heading_accordion').click(function(){

        $(this).parents('.footer_block_grid').find('.mobile_quick_link').toggleClass("active_grid");
        $(this).toggleClass('active_link');
    });
  }
  
  
});